import createApp from '@shopify/app-bridge';
import { Toast } from '@shopify/app-bridge/actions';

class CsAppBridge {

  static debug = false;
  static app;
  static apiKey;

  static translator;
  static env;

  // Use to authenticate with backend, must be provided in all API requests
  static host;
  static storeName;

  static log (...args) {
    if (this.debug) {
      console.log('---AppBridge: ', ...args);
    }
  }

  static t (text) {
    return this.translator ? this.translator.t(text) : text;
  }

  static init (environment, translator) {
    this.debug = !environment.isProdMode();
    this.apiKey = environment.getApiKey();
    this.host = environment.getHost();
    this.storeName = environment.getStoreName();
    this.translator = translator;
    this.env = environment;

    return new Promise((resolver, rejection) => {
      if (!this.isValidApp()) {
        rejection('Invalid app!');
      }

      const app = this.getApp();
      // In dev mode, app.getState() won't process, it is stuck in pending
      const locale = this.env.getLocale();
      if (locale) {
        resolver(locale);
      } else {
        const appState = app.getState();
        this.log('State', appState);
        appState.then(data => {
          this.log('App data', data);
          const { staffMember } = data;
          resolver(staffMember.locale);
        });
      }
    });
  }

  static createApp () {
    this.app = createApp(this.getAppBridgeConfig());
    this.log('Created app', this.app);
  }

  static getApp () {
    if (!this.app) {
      this.createApp();
    }
    return this.app;
  }

  static isValidApp () {
    return !!(this.apiKey && this.host);
  }

  static getAppBridgeConfig () {
    return {
      apiKey: this.apiKey,
      host: this.host,
      forceRedirect: !this.debug,
    };
  }

  static getStoreName () {
    return this.storeName;
  }

  static toast (message) {
    this._displayToast(message);
  }

  static toastError (error) {
    this._displayToast(error, true);
  }

  static _displayToast (message, isError = false) {
    Toast.create(this.getApp(), {
      message: this.t(message),
      isError: isError || false,
      duration: 1000
    }).dispatch(Toast.Action.SHOW);
  }
}

export default CsAppBridge;
